import { useState, useEffect } from "react";
import apiClient from "../services/apiClient";

/**
 * Hook to resolve the current company ID.
 * Fetches from /api/companies and returns the first company's ID.
 * Caches the result in sessionStorage to avoid repeated API calls.
 */
export function useCompanyId(): { companyId: string; loading: boolean } {
  const [companyId, setCompanyId] = useState<string>(() => {
    return sessionStorage.getItem("currentCompanyId") || "";
  });
  const [loading, setLoading] = useState(!companyId);

  useEffect(() => {
    if (companyId) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await apiClient.get("/api/companies");
        if (cancelled) return;
        const list = res.companies || [];
        if (list.length > 0) {
          const id = list[0].id;
          setCompanyId(id);
          sessionStorage.setItem("currentCompanyId", id);
        }
      } catch (e) {
        console.error("Failed to load companies:", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [companyId]);

  return { companyId, loading };
}
